import { inject, Injectable } from "@angular/core";
import { MobileSoftwareUpgradeApiService } from "../../core/http/apiservice";

import { firstValueFrom } from "rxjs";
import { authorizationEndPoint } from "../../../assets/data/apiconstant";
import { CsrfResponse } from "./csrf-response-model";
import { CsrfTokenStoreService } from "../../shared/stores/csrf-token-store-service";

@Injectable({
  providedIn: "root"
})
export class CsrfService {
  private apiService = inject(MobileSoftwareUpgradeApiService);
  private CsrfTokenStore = inject(CsrfTokenStoreService);
  async loadCsrfToken(): Promise<void> {
    try {
      const httpResponse = await firstValueFrom(
        this.apiService.get<CsrfResponse>(`${authorizationEndPoint.generateCSRFToken}`, {
          observe: "response"
        })
      );

      // Read values from response headers
      const csrfTokenFromHeader = httpResponse.headers.get("csrfrequesttoken");
      const cookieTokenFromHeader = httpResponse.headers.get("cookietoken");

      this.CsrfTokenStore.setToken(csrfTokenFromHeader ?? "");
      this.CsrfTokenStore.setCookie(cookieTokenFromHeader ?? "");
    } catch (error) {
      console.error("CSRF API Failed", error);
    }
  }
}
